import General from "@/assets/langpacks/General";

export function dateWithWordFilter(value) {
  let temp = new Date(value);
  let RetVal =
    temp.getDate() +
    " " +
    General.Months.geo[temp.getMonth()] +
    " " +
    temp.getFullYear();

  return RetVal;
}

export function dateWithWordFullFilter(value) {
  let temp = new Date(value);
  let RetVal =
    temp.getDate() +
    " " +
    General.Months.geo[temp.getMonth()] +
    " " +
    temp.getFullYear() +
    " " +
    (temp.getHours() < 10 ? "0" : "") +
    temp.getHours() +
    ":" +
    (temp.getMinutes() < 10 ? "0" : "") +
    temp.getMinutes() +
    ":" +
    (temp.getSeconds() < 10 ? "0" : "") +
    temp.getSeconds();
  return RetVal;
}
